import React from 'react';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import withSearch, { WithSearchProps } from '../../_hocs/withSearch';
import Flex from '@wix/da-ds/pkg/Flex';

import noSearchResultStyles from './NoSearchResults.scss';

export interface Props {
  className?: string;
}

const enhance = compose(withSearch);
export const NoSearchResults: React.FC<Props & WithSearchProps> = ({
  unsetSearchQuery,
  unsetSearchInput,
}) => {
  const { t } = useTranslation();
  return (
    <Flex
      fullWidth
      fullHeight
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <SearchIcon className={noSearchResultStyles['icon']} />
      <div className={noSearchResultStyles['no-results']}>
        {t('mediapopup.search.noResultsFound')}
      </div>
      <div className={noSearchResultStyles['go-back-to']}>
        {t('mediapopup.search.goBackTo')}
        <button
          className={noSearchResultStyles['all-artworks-button']}
          onClick={() => {
            unsetSearchQuery();
            unsetSearchInput();
          }}
        >
          {t('mediapopup.allArtworks')}
        </button>
      </div>
    </Flex>
  );
};
NoSearchResults.displayName = 'NoSearchResults';

export default enhance(NoSearchResults) as any as React.ComponentClass<Props>;
